<script>
import Layout from "@/router/layouts/main";
import { mapState } from "vuex";
import Banners from "@/components/widgets/banners";

export default {
  locales: {
    pt: {},
    es: {},
  },
  components: {
    Layout,
    Banners,
  },
  computed: {
    ...mapState({
      account: (state) => state.account,
    }),
    telemedicinaServiceClass() {
      if (
        this.account &&
        this.account.user &&
        this.account.user.plan &&
        this.account.user.plan.current &&
        this.account.user.plan.current.service
      ) {
        return this.account.user.plan.current.service.telemedicina;
      }
      return "";
    },
  },
  data() {
    return {
      sections: [
      {
        title: "Presenciais",
        items: [
        {
          to: "/telemedicina/consultas",
          title: "Consultas",
          description: "Agende consultas presenciais",
          icon: ["M8 15h3v3h2v-3h3v-2h-3v-3h-2v3H8z", "M19 4h-2V2h-2v2H9V2H7v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm.002 16H5V8h14l.002 12z"],
        },
        {
          to: "/telemedicina/exames",
          title: "Exames",
          description: "Agende seus exames",
          icon: ["M8.648 14.711 11.997 18l3.35-3.289a2.129 2.129 0 0 0 0-3.069 2.225 2.225 0 0 0-3.126 0l-.224.219-.224-.219a2.224 2.224 0 0 0-3.125 0 2.129 2.129 0 0 0 0 3.069z", "M19 4h-2V2h-2v2H9V2H7v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm.002 16H5V8h14l.002 12z"],
        },
        ],
      },
      {
        title: "Telemedicina",
        items: [
        {
          to: "/telemedicina/plantao",
          title: "Consultas",
          description: "Fale com um médico por vídeo",
          icon: ["M18 10.5V7c0-.55-.45-1-1-1H5c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4z"],
        },
        {
          to: "/telemedicina/agendamentos",
          title: "Agendamentos",
          description: "Veja suas consultas marcadas",
          icon: ["M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z", "M13 7h-2v6h6v-2h-4z"],
        },
        ],
      },
      {
        title: "Outros",
        items: [
        {
          to: "/telemedicina/medicamentos",
          title: "Medicamentos",
          description: "Medicamentos e farmácia",
          icon: ["M19.5 3.5 18 2l-1.5 1.5L15 2l-1.5 1.5L12 2l-1.5 1.5L9 2 7.5 3.5 6 2v14H3v3c0 1.66 1.34 3 3 3h12c1.66 0 3-1.34 3-3V2l-1.5 1.5zM19 19c0 .55-.45 1-1 1s-1-.45-1-1v-3H8V5h11v14z", "M9 7h6v2H9zm0 4h6v2H9z"],
        },
        {
          to: "/telemedicina/carteirinha",
          title: "Carteirinha",
          description: "Sua carteirinha digital",
          icon: ["M19 2H5c-1.103 0-2 .897-2 2v13c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm0 15H5V4h14v13z", "M12 10c1.151 0 2-.848 2-2s-.849-2-2-2c-1.15 0-2 .848-2 2s.85 2 2 2zm0 1c-2.209 0-4 1.612-4 3.6v.386h8V14.6c0-1.988-1.791-3.6-4-3.6z"],
        },
        ],
      },
      ],
    };
  },
  methods: {},
  mounted() {},
};
</script>

<template>
  <Layout>
    <div class="page-title-box d-flex justify-content-between align-items-center">
      <div>
        <h5 class="text-capitalize">Olá {{ account.user.name.split(' ')[0].toLowerCase() }}!</h5>
      </div>
    </div>

    <Banners></Banners>

    <template v-if="account && account.user && account.user.plan && account.user.plan.current && account.user.plan.current.service">
      <div v-for="section in sections" :key="section.title" class="mb-4">
        <h6 class="text-uppercase text-muted mb-3">{{ section.title }}</h6>
        <div class="home-grid">
          <router-link
            v-for="item in section.items"
            :key="item.to"
            tag="a"
            :to="item.to"
            class="home-tile"
            :class="telemedicinaServiceClass"
          >
            <div class="home-tile-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" style="fill: currentColor;">
                <path v-for="(path, index) in item.icon" :key="index" :d="path"></path>
              </svg>
            </div>
            <div class="home-tile-text">
              <div class="home-tile-title">{{ item.title }}</div>
              <div class="home-tile-desc">{{ item.description }}</div>
            </div>
          </router-link>
        </div>
      </div>
    </template>
  </Layout>
</template>

<style lang="scss" scoped>
.home-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}

.home-tile {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  padding: 16px;
  background: #fff;
  border-top: 4px solid #35D739;
  border-radius: 12px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  color: #212529;
  transition: transform 0.2s;

  &:hover {
    transform: translateY(-2px);
    color: #212529;
    text-decoration: none;
  }

  &.inactive {
    filter: grayscale(1);
    opacity: 0.85;
  }
}

.home-tile-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  border-radius: 12px;
  background: rgba(53, 215, 57, 0.12);
  color: #35D739;
}

.home-tile-text {
  min-width: 0;
  width: 100%;
}

.home-tile-title {
  font-size: 14px;
  font-weight: 700;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.home-tile-desc {
  margin-top: 2px;
  font-size: 11px;
  color: #6c757d;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

@media (min-width: 576px) {
  .home-grid {
    gap: 16px;
  }

  .home-tile {
    flex-direction: row;
    align-items: center;
    gap: 16px;
    padding: 24px;
  }

  .home-tile-icon {
    padding: 12px;
  }

  .home-tile-title {
    font-size: 16px;
  }

  .home-tile-desc {
    font-size: 12px;
  }
}
</style>
